import React, { useEffect, useState } from "react"

//components
import ThriveModal from "./ThriveModal";
import BasicButton from "../buttons/BasicButton";
import ContentOrderSetter from "../content/ContentOrderSetter";

//interfaces
import { IReorderContentTilesModal } from "../../../interfaces/modals/modal";




const ReorderContentTilesModal = ({showModal, onHideModal, setContentTileOrder, contentTiles} : IReorderContentTilesModal) => {
    const [tempContentTiles, setTempContentTiles] = useState([...contentTiles]);

    useEffect(() => {
        setTempContentTiles([...contentTiles]);
    }, [contentTiles, showModal]);

    return (
        <ThriveModal 
            showModal={showModal} 
            canEscapeClose
            className="reorder-content-tiles-modal"
            headerContent={
                <h1 className="reorder-content-header">
                    Reorder tiles
                </h1>
            } 
            bodyContent={
                <div className="reorder-content-modal-body">
                    <div className="reorder-explainer">
                        Drag tiles to reorder them, or use the arrow buttons to move them up and down.
                    </div>

                    <div className="content-order-component">
                        <ContentOrderSetter 
                            content={tempContentTiles} 
                            setContent={setTempContentTiles} 
                        />
                    </div>
                </div>
            } 
            footerContent={
                <BasicButton    
                    className="save-content-order-button"
                    content={"Done"}
                    ariaLabel={"Done"}
                    onButtonClick={() => setContentTileOrder(tempContentTiles)}
                />
            } 
            onCloseClick={onHideModal}            
        />
    );
}

export default ReorderContentTilesModal